module.exports = __webpack_public_path__ + "static/media/checked-tick.4db2ee2e.svg";